import { render, staticRenderFns } from "./AccountInformationItem.vue?vue&type=template&id=3fb58f59&scoped=true"
import script from "./AccountInformationItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountInformationItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountInformationItem.vue?vue&type=style&index=0&id=3fb58f59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb58f59",
  null
  
)

export default component.exports